import React, {Component} from 'react';
import {Table} from 'antd';
import moment from 'moment';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {queryIncuBusinessRemind} from '@api/incubator/business';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      stationSum: 0,
    };
  }

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.contract45Page || 1;
    this.getIncuBusinessRemind();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.getIncuBusinessRemind();
    }
  }

  getIncuBusinessRemind = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryIncuBusinessRemind({
      incubatorUuid: this.incuUuid || '',
      start: this.current || 1,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data.list,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
          stationSum: res.data.stationSum,
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getIncuBusinessRemind();
    const { currentShow } = this.props;
    currentShow.contract45Page = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        render: (text, record) => (
          <Link to={`/incubator/contract/${record.uuid}/info`}>{record.no}</Link>
        ),
      },
      {
        title: '园区',
        dataIndex: 'incubator',
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
      },
      {
        title: '到期时间',
        dataIndex: 'deadline',
        render: (text, record) =>
          text ? (
            <span>
              {moment.unix(text / 1000).format('YYYY-MM-DD')}
              (剩余{Math.ceil(Math.abs(record.businessInterval) / 1440)}天)
            </span>
          ) : null,
      },
      {
        title: '款项状态',
        dataIndex: 'status',
        render: (text, record) => <span>{text === 0 ? '没有匹配' : '完成匹配'}</span>,
      },
      {
        title: '操作',
        dataIndex: 'termStatus', // 0审核中；1已完成
        width: 160,
        render: (text, record) => {
          return !(text > 0 || text === 0) ? (
            <Link to={`/incubator/contract/${record.uuid}/termination`}>终止合同</Link>
          ) : (
            <span>终止合同({text === 0 ? '审核中' : '已完成'})</span>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      stationSum,
      // addressSum
    } = this.state;
    const { total } = pagination;
    return (
      <div>
        <div className="tips">
          45天内到期合同(
          <span className="content">
            {total}份合同/{stationSum}个工位
          </span>
          )
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default connect(state => ({ currentShow: state.wb_tab_current }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/contract/Table45.js